import React, { Suspense, lazy } from 'react';
import Switch from 'react-router-dom/Switch';
import Loading from '../components/Loader';
import AppliedRoute from '../components/hoc/AppliedRoute';
import AuthenticatedRoute from '../components/hoc/AuthenticatedRoute';

const Secured = lazy(() => import('./Secured/Secured'));
const AsyncHome = lazy(() => import('./Profile/Profile'));
const AsyncCalendar = lazy(() => import('./Calendar/Calendar'));
const AsyncNotFound = lazy(() => import('./NotFound/NotFound'));
const AsyncInactiveUser = lazy(() => import('./InactiveUser/InactiveUser'));
const AsyncTable = lazy(() => import('./Table/AdminTable'));
const AsyncUserTable = lazy(() => import('./Table/UserTable'));
const AsyncTeams = lazy(() => import('./Teams/Teams'));
const AsyncEmployyeTable = lazy(() => import('./EmployyeTable/EmployeeTable'));
const AsyncAdminPanel = lazy(() => import('./AdminPanel/AdminPanel'));
const AsyncMyEvent = lazy(() => import('./Table/MyEventsTable'));

export default ({ childProps }) => (
    <Suspense fallback={<Loading />}>
        <Switch>
            <AppliedRoute
                path="/"
                exact
                component={Secured}
                props={childProps}
            />
            <AuthenticatedRoute
                path="/calendar"
                exact
                component={AsyncCalendar}
                props={childProps}
            />
            <AuthenticatedRoute
                path="/table"
                exact
                component={AsyncTable}
                props={childProps}
            />
            <AuthenticatedRoute
                path="/userTable"
                exact
                component={AsyncUserTable}
                props={childProps}
            />
            <AuthenticatedRoute
                path="/employeelist"
                exact
                component={AsyncEmployyeTable}
                props={childProps}
            />
            <AuthenticatedRoute
                path="/teams"
                exact
                component={AsyncTeams}
                props={childProps}
            />
            <AuthenticatedRoute
                path="/panel"
                exact
                component={AsyncAdminPanel}
                props={childProps}
            />
            <AuthenticatedRoute
                path="/home"
                exact
                component={AsyncHome}
                props={childProps}
            />
            <AuthenticatedRoute
                path="/myEvent"
                exact
                component={AsyncMyEvent}
                props={childProps}
            />
            <AppliedRoute component={AsyncInactiveUser} props={childProps} />
            <AppliedRoute component={AsyncNotFound} props={childProps} />
        </Switch>
    </Suspense>
);



// WEBPACK FOOTER //
// ./src/routes/Routes.js